/**
 * Quiz response mapping utilities for normalizing worker/API responses.
 */
/** Map question type from API format (hyphen) to internal format (underscore). */
export function mapQuestionType(type) {
    const typeMap = {
        'multiple_choice': 'multiple_choice',
        'true_false': 'true_false',
        'short_answer': 'short_answer',
        'open_ended': 'open_ended',
        'scenario_based': 'scenario_based',
        'multiple-choice': 'multiple_choice',
        'true-false': 'true_false',
        'short-answer': 'short_answer',
        'open-ended': 'open_ended',
        'scenario-based': 'scenario_based',
    };
    return typeMap[type] || 'multiple_choice';
}
/** Map difficulty/level string to normalized format. */
export function mapDifficulty(difficulty) {
    const difficultyMap = {
        beginner: 'easy',
        intermediate: 'medium',
        advanced: 'hard',
        easy: 'easy',
        medium: 'medium',
        hard: 'hard',
    };
    return difficultyMap[difficulty?.toLowerCase()] || 'medium';
}
/** Map difficulty to level string for API. */
export function mapDifficultyToLevel(difficulty) {
    const levelMap = {
        easy: 'beginner',
        medium: 'intermediate',
        hard: 'advanced',
    };
    return levelMap[difficulty] || 'intermediate';
}
